// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating_btn, .floating_btn2 {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
@media (max-width: 899px) {
  .floating_btn, .floating_btn2 {
    width: 40px;
    height: 40px;
    bottom: 16px;
    right: 16px;
  }
}
@keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}
.floating_btn .contact_icon, .floating_btn2 .contact_icon {
  background-color: #42db87;
  color: #fff;
  width: 60px;
  height: 60px;
  font-size: 30px;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translatey(0px);
  animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 #42db87;
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  text-decoration: none !important;
  transition: all 300ms ease-in-out;
}
@media (max-width: 899px) {
  .floating_btn .contact_icon, .floating_btn2 .contact_icon {
    width: 40px;
    height: 40px;
    transition: none;
    animation: none;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }
}
.floating_btn .contact_icon svg, .floating_btn2 .contact_icon svg {
  width: 30px;
  height: 30px;
  fill: #fff;
}
@media (max-width: 899px) {
  .floating_btn .contact_icon svg, .floating_btn2 .contact_icon svg {
    width: 24px;
    height: 24px;
  }
  .floating_btn2 {
    bottom: 74px;
  }
}
.floating_btn2 .contact_icon {
  background: #2196f3;
}
@media (max-width: 899px) {
  .floating_btn2 .contact_icon svg {
    width: 20px;
    height: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EAZF;IAaI,WAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;EAEF;AACF;AAAE;EACE;IACE,2CAAA;EAEJ;AACF;AACE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;EAIA,6DAAA;EACA,gCAAA;EACA,iCAAA;AACJ;AACI;EAtBF;IAuBI,WAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IAGE,wEAAA;EAAN;AACF;AAEI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAAN;AAEM;EALF;IAMI,WAAA;IACA,YAAA;EACN;EAMF;IAII,YAAA;EAJF;AALF;AAYE;EACE,mBAAA;AAJJ;AAOM;EADF;IAEI,WAAA;IACA,YAAA;EAJN;AACF","sourcesContent":[".floating_btn {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n\n  @media(max-width: 899px) {\n    width: 40px;\n    height: 40px;\n    bottom: 16px;\n    right: 16px;\n  }\n\n  @keyframes pulsing {\n    to {\n      box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);\n    }\n  }\n\n  .contact_icon {\n    background-color: #42db87;\n    color: #fff;\n    width: 60px;\n    height: 60px;\n    font-size: 30px;\n    border-radius: 50px;\n    text-align: center;\n    box-shadow: 2px 2px 3px #999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: translatey(0px);\n    animation: pulse 1.5s infinite;\n    box-shadow: 0 0 0 0 #42db87;\n    -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\n    -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\n    -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\n    animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\n    text-decoration: none !important;\n    transition: all 300ms ease-in-out;\n\n    @media(max-width: 899px) {\n      width: 40px;\n      height: 40px;\n      transition: none;\n      animation: none;\n      // box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 30%),\n      //   0px 1px 3px 1px rgb(0 0 0 / 20%);\n        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n    }\n\n    svg {\n      width: 30px;\n      height: 30px;\n      fill: #fff;\n\n      @media(max-width: 899px) {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n}\n\n\n.floating_btn2 {\n  @extend .floating_btn;\n\n  @media(max-width: 899px) {\n    bottom: 74px;\n  }\n\n  .contact_icon {\n    background: #2196f3;\n\n    svg {\n      @media(max-width: 899px) {\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
